import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";

import {labelDashboardLeftMenu} from "../DashboardMenu/LabelDashboardMenu";


const useStyles = makeStyles({
    root: {
        minWidth: 275,
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
});

export default function BeagleSettings(props) {
    const classes = useStyles();

    const langPref = props.beagleLanguagePreference;
    const mathPref = props.beagleMathPreference;
    const labelSettings = labelDashboardLeftMenu.labelSettings[langPref];
    const labelImperialMath = labelDashboardLeftMenu.labelMathPref.i[langPref];
    const labelMetricMath = labelDashboardLeftMenu.labelMathPref.m[langPref];
    const labelMathPreference = labelDashboardLeftMenu.labelMathPreference[langPref];

    return (
        <Grid item xs={12} md={6} lg={4}>
            <Card className={classes.root}>
                <CardContent>
                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                        {labelSettings}
                    </Typography>
                    <Typography variant="h5" component="h2">
                        {labelMathPreference}
                    </Typography>
                    <FormControl component="fieldset">
                        <RadioGroup aria-label="math1" name="math1" value={mathPref}
                                    onChange={props.handleBeagleMathPreference}>
                            <FormControlLabel value="i" control={<Radio color="primary"/>}
                                              label={labelImperialMath}/>
                            <FormControlLabel value="m" control={<Radio color="primary"/>} label={labelMetricMath}/>
                        </RadioGroup>
                    </FormControl>
                </CardContent>
            </Card>
        </Grid>
    );
}
